var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.short)?_c('span',[(_vm.hours !== 0)?_c('span',[_vm._v(_vm._s(_vm.$n(_vm.hours))+" :")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.$n(_vm.minutes))+"\n  "),(_vm.seconds !== 0 && !_vm.ignoreSeconds)?_c('span',[_vm._v(" : "+_vm._s(_vm.numberToString(_vm.seconds)))]):_vm._e()]):_c('span',[_vm._v("\n  "+_vm._s(_vm.minutesInLongFormat)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce326f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/formatters/Minute.vue
// module id = null
// module chunks = 